import { createSelector } from 'reselect'

const getMedia = state => state.interactiveVideoCreation.media

export default createSelector(
	[ getMedia ],
	media => !!media.asset.uid
)
